import { useState } from "react";

interface Props {
  dateRange: number;
  from?: string;
  to?: string;
  defaultDateRange: number;
  onChange: (next: { dateRange?: number; from?: string; to?: string }) => void;
}

const PRESETS = [7, 30, 60];

// Analytics collection began 2026-03-04; the earliest selectable day is the day after.
const ANALYTICS_START = "2026-03-05";

export function DateRangeFilter({
  dateRange,
  from,
  to,
  defaultDateRange,
  onChange,
}: Props) {
  const isCustom = !!(from && to);
  const [customOpen, setCustomOpen] = useState(isCustom);

  // Native <input type="date"> min/max only constrain the calendar UI; a typed value can still
  // slip through, so clamp into [ANALYTICS_START, today] before propagating.
  const today = new Date().toISOString().slice(0, 10);
  const clampDay = (v: string): string | undefined =>
    !v ? undefined : v < ANALYTICS_START ? ANALYTICS_START : v > today ? today : v;

  return (
    <div className="filter-group">
      <div className="label">Date range</div>
      <div className="date-presets">
        {PRESETS.map((n) => (
          <button
            type="button"
            key={n}
            className={!isCustom && dateRange === n ? "active" : ""}
            onClick={() => onChange({ dateRange: n, from: undefined, to: undefined })}
          >
            {n}d
          </button>
        ))}
        <button
          type="button"
          className={isCustom ? "active" : ""}
          onClick={() => setCustomOpen((o) => !o)}
        >
          <span
            className="material-symbols-rounded"
            style={{ fontSize: 14, verticalAlign: "-2px", marginRight: 2 }}
          >
            calendar_today
          </span>
          Custom
        </button>
      </div>
      {customOpen && (
        <div className="date-custom">
          <label>
            From{" "}
            <input
              type="date"
              value={from ?? ""}
              min={ANALYTICS_START}
              max={today}
              onChange={(e) => onChange({ from: clampDay(e.target.value), to })}
            />
          </label>
          <label>
            To{" "}
            <input
              type="date"
              value={to ?? ""}
              min={ANALYTICS_START}
              max={today}
              onChange={(e) => onChange({ from, to: clampDay(e.target.value) })}
            />
          </label>
          {isCustom && (
            <button
              type="button"
              className="date-custom-clear"
              onClick={() =>
                onChange({ dateRange: defaultDateRange, from: undefined, to: undefined })
              }
            >
              Clear
            </button>
          )}
        </div>
      )}
    </div>
  );
}
